// Firebase Web SDK initialization
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);

// Cache the verifier to avoid re-creating it (Firebase requires exactly one per DOM element)
let recaptchaVerifier = null;

export const getRecaptchaVerifier = (containerId = "recaptcha-container") => {
  if (recaptchaVerifier) return recaptchaVerifier;
  recaptchaVerifier = new RecaptchaVerifier(firebaseAuth, containerId, {
    size: "invisible",
    callback: () => {},
    "expired-callback": () => {},
  });
  return recaptchaVerifier;
};

export const resetRecaptcha = () => {
  try {
    if (recaptchaVerifier) {
      recaptchaVerifier.clear();
    }
  } catch (e) {
    // ignore
  }
  recaptchaVerifier = null;
  document.querySelectorAll('iframe[src*="recaptcha/api2/bframe"], iframe[src*="recaptcha/enterprise/bframe"]').forEach((f) => {
    let el = f;
    while (el.parentElement && el.parentElement !== document.body) el = el.parentElement;
    if (el.parentElement === document.body) el.remove();
  });
};

export const sendFirebaseOTP = async (phoneE164, containerId = "recaptcha-container") => {
  const verifier = getRecaptchaVerifier(containerId);
  const confirmation = await signInWithPhoneNumber(firebaseAuth, phoneE164, verifier);
  return confirmation;
};
